module.exports = __webpack_public_path__ + "static/media/no-field-found.06e06d49.svg";